import type { ReactElement } from 'react';

import get from 'lodash/get';
import { useNavigate, useLocation } from 'react-router-dom';

import type { ModalClose } from '../../types';

type RenderProps = {
  onClose: ModalClose;
};

type Props = {
  render: (params: RenderProps) => ReactElement;
  hash: string;
};

const HashRoute = ({ hash, render }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const match = location.hash === hash;
  const onClose = () => {
    const shouldGoBack = get(window, 'history.state.state.shouldGoBack');
    if (shouldGoBack) {
      navigate(-1);
    } else {
      // In the cases like:
      // On the mWeb dayview page, when filter is selected,
      // It will change the url by updateSearchParamsUrl using window.history.pushState.
      // See: apps/client/src/services/url/url.ts
      // Then window.history.state.state.shouldGoBack is lost.
      // And the location from react-router-dom does not match window.location.
      // To resolve this issue, we push the latest window.location.search to react-router-dom
      // instead of using navigate(-1).
      const { search } = window.location;
      navigate({ ...location, search, hash: undefined });
    }
  };

  if (match && render) {
    return render({ onClose });
  }
  return null;
};

export default HashRoute;
export type { RenderProps };
